export const INTEGRATIONS_PATH = "/platform/settings/integrations";

export const integrationPath = (id: string) => `${INTEGRATIONS_PATH}/${id}`;
